import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePostRelations } from "redux/features/ActivityPostSlice";
import { FollowCardItem, WaterMark, NetworkPopoverStyle } from "./Network.style";
import { BasicIconButton, Button, CustomPopover } from "components";
import { MenuItem } from "@mui/material";

import { ReactComponent as SampleProfile } from "assert/images/Common/profileImg.svg";
import { ReactComponent as More } from "assert/images/Home/moreHorizantal.svg";
import { ReactComponent as Mute } from "assert/images/More/mute.svg";
import { ReactComponent as UnMute } from "assert/images/More/unmute.svg";
import { ReactComponent as Block } from "assert/images/More/block.svg";
import DynModel from "components/Modal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function FollowersRequest({ item, activeKey, listWithDrawID, isLoadingBtn, handleSetLoading }) {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [openPopover, setOpenPopover] = useState(false);
  const [openConfirmModel, setOpenConfirmModel] = useState(null);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const loggedInUserId = getProfile?.userId;

  useEffect(() => {
    setOpenPopover(false);
    setOpenConfirmModel(null);
  }, [isLoadingBtn]);

  const handleLoading = () => {
    handleSetLoading(true);
  };

  const headline = item?.headline || item?.followerInfo?.headline;
  const profileImage = item?.profileImage || item?.followerInfo?.profileImage;
  const coverImage = item?.coverImage || item?.followerInfo?.coverImage;
  const username = item?.username || item?.followerInfo?.username;
  const displayName = item?.displayName || item?.followerInfo?.displayName;
  const listUserId = item?.followerInfo?.userId;
  const followersCount = item?.followerInfo?.followerCount;
  const followingCount = item?.followerInfo?.followingCount;
  const postCount = item?.followerInfo?.postCount;
  const isFollowback = item?.followerInfo?.isFollowback;

  const autoFollowRequest = item?.autoFollowRequest || item?.followerInfo?.autoFollowRequest;

  const handleSendRequest = (key, accepted = undefined, payloadKey) => {
    handleLoading();
    const payload = {
      userId: loggedInUserId,
      followerId: listUserId,
      key,
      accepted,
      submitKey: payloadKey,
      username: getProfile?.username
    };
    if (accepted === undefined) {
      delete payload.accepted;
    }
    if (payloadKey === "UNFOLLOW") {
      payload.isUnFollow = true;
    } else if (payloadKey === "REMOVE") {
      payload.isRemove = true;
    }
    dispatch(changePostRelations(payload));
  };

  const handleMuteBlock = (data, key) => {
    handleLoading();
    const payload = {
      key,
      followerId: listUserId,
      userId: loggedInUserId,
    };
    if (key === "MUTE") {
      payload.mute = !data?.isMuted;
    } else {
      payload.block = !data?.isBlocked;
    }
    dispatch(changePostRelations(payload));
  };

  const PostDropdown = () => {
    return (
      <NetworkPopoverStyle>
        <MenuItem onClick={() => handleMuteBlock(item, "MUTE")}>
          {item?.isMuted ? <UnMute /> : <Mute />}
          {item?.isMuted ? t('Network.UnMute') : t('Network.Mute')}@{username}
        </MenuItem>
        <MenuItem onClick={() => handleMuteBlock(item, "BLOCK")}>
          <Block />
          {item?.isBlocked ? t('Network.UnBlock'): t('Network.Block')}@{username}
        </MenuItem>
      </NetworkPopoverStyle>
    );
  };

  const handlesetParams = () => {
    if (activeKey === 0) {
      handleSendRequest("WITHDRAW");
    } else if (activeKey === 1) {
      handleSendRequest("WITHDRAW");
    } else if (activeKey === 2) {
      if (listWithDrawID.includes(listUserId)) {
        handleSendRequest("WITHDRAW");
      } else {
        handleSendRequest("UNFOLLOW", undefined, "REMOVE");
      }
    } else if (activeKey === 3) {
      handleSendRequest("UNFOLLOW", undefined, "UNFOLLOW");
    }
  }

  const handleFollowAction = () => {
    return autoFollowRequest ? (
      listWithDrawID.includes(listUserId) ? (
        <Button
          loading={isLoadingBtn}
          label={"UnFollow"}
          variant="text"
          color={"error"}
          customStyles="follow-action"
          onClick={() => handleSendRequest("UNFOLLOW", undefined, "UNFOLLOW")}
        />
      ) : (
        <Button
          loading={isLoadingBtn}
          label={activeKey === 2 ? "Follow Back" : "Follow"}
          variant="text"
          customStyles="follow-action"
          onClick={() => handleSendRequest("FOLLOW")}
        />
      )
    ) : listWithDrawID.includes(listUserId) ? (
      <Button
        loading={isLoadingBtn}
        label={t('Network.WithDraw')}
        variant="text"
        customStyles="follow-action"
        onClick={() => setOpenConfirmModel(listUserId)}
      />
    ) : (
      !isFollowback && (
        <Button
          loading={isLoadingBtn}
          label={t(activeKey === 2 ? "Network.FollowBack" : "Network.Follow")}
          variant="text"
          customStyles="follow-action"
          onClick={() => handleSendRequest("FOLLOW")}
        />
      )
    );
  };

  return (
    <FollowCardItem>
      <div className="follow-close-icon">
        {[3].includes(activeKey) && (
          <CustomPopover
            isOpen={openPopover}
            handlePopoverClick={() => {
              setOpenPopover(true);
            }}
            action={<BasicIconButton icon={<More />} size="small" />}
            content={PostDropdown(item)}
          />
        )}
      </div>
      <>
        <div className="follow-img-container">
          {profileImage ? (
            <img className="user-profile-img" src={profileImage} />
          ) : (
            <SampleProfile className="user-profile-img" />
          )}
          {coverImage ? (
            <img className="user-background-img" src={coverImage} />
          ) : (
            <WaterMark>
              {[...Array(6)].map((_, index) => {
                return (
                  <div key={index} className="watermark-text">
                    WafyNet
                  </div>
                );
              })}
            </WaterMark>
          )}
        </div>
        <div className="follow-content">
          <div className="follow-names">
            <div onClick={() => navigate('/profile/' + username)}>{displayName || username}</div>
            <div>{username}</div>
          </div>
          {activeKey !== 5 && <div className="follow-headline">{headline}</div>}
          <div className="footer-with-count">
            {activeKey !== 5 &&
              <div className="follow-user-activity">
                <div>
                  <div className="follow-action-count">{followersCount || 0}</div>
                  <div>{t('Network.Followers')}</div>
                </div>
                <div>
                  <div className="follow-action-count">{postCount || 0}</div>
                  <div>{t('Network.Post')}</div>
                </div>
                <div>
                  <div className="follow-action-count">{followingCount || 0}</div>
                  <div>{t('Network.Following')}</div>
                </div>
              </div>
            }
            <div>
              {/* || item?.isForFollowRequest */}
              {activeKey === 0 && handleFollowAction()}
              {activeKey === 1 &&
                (!item?.isForFollowRequest ? (
                  <div className="action-btn-flex">
                    <Button
                      loading={isLoadingBtn}
                      label={t('Network.Accept')}
                      variant="text"
                      customStyles="follow-action"
                      onClick={() => handleSendRequest("FOLLOW REQUEST", true)}
                    />
                    <Button
                      loading={isLoadingBtn}
                      label={t('Network.Cancel')}
                      color={"error"}
                      variant="text"
                      customStyles="follow-action"
                      onClick={() => handleSendRequest("FOLLOW REQUEST", false)}
                    />
                  </div>
                ) : (
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.WithDraw')}
                    variant="text"
                    customStyles="follow-action"
                    onClick={() => setOpenConfirmModel(listUserId)}
                  />
                ))}
              {activeKey === 2 && (
                <div className="action-btn-flex">
                  {handleFollowAction()}
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.Remove')}
                    color={"error"}
                    variant="text"
                    customStyles="follow-action"
                    onClick={() => setOpenConfirmModel(listUserId)}
                  />
                </div>
              )}
              {activeKey === 3 && (
                <Button
                  loading={isLoadingBtn}
                  label={t('Network.UnFollow')}
                  variant="text"
                  color={"error"}
                  customStyles="follow-action"
                  onClick={() => setOpenConfirmModel(listUserId)}
                />
              )}
              {activeKey === 4 &&
                (!item?.isMuted ? (
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.Mute')}
                    variant="text"
                    customStyles="follow-action"
                    onClick={() => handleMuteBlock(item, "MUTE")}
                  />
                ) : (
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.UnMute')}
                    variant="text"
                    customStyles="follow-action"
                    onClick={() => handleMuteBlock(item, "MUTE")}
                  />
                ))}
              {activeKey === 5 &&
                (!item?.isBlocked ? (
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.Block')}
                    variant="text"
                    color={"error"}
                    customStyles="follow-action"
                    onClick={() => handleMuteBlock(item, "BLOCK")}
                  />
                ) : (
                  <Button
                    loading={isLoadingBtn}
                    label={t('Network.UnBlock')}
                    variant="text"
                    customStyles="follow-action"
                    onClick={() => handleMuteBlock(item, "BLOCK")}
                  />
                ))}
            </div>
          </div>
        </div>
      </>
      <DynModel
        removeHeader
        modalchanges="network"
        handleCancelModal={() => setOpenConfirmModel(null)}
        openModal={openConfirmModel !== null}
        content={
          <div className="confirmModal">
            <>
              {(activeKey === 0 || activeKey === 1) || (activeKey === 2 && listWithDrawID.includes(listUserId)) ? (
                <div>
                  <div className="title">{t('Network.WithDrawModal')}</div>
                  <div className="sub-title">{t('Network.RequestForTwoDays')}</div>
                </div>
              ) : (
                <div className="title">{t('Network.ConfirmUnfollow')} {activeKey === 2 ? t('Network.Remove') : t('Network.Unfollow')}?</div>
              )}
            </>
            <div>
              <Button label={t('Network.Cancel')} variant="text" onClick={() => setOpenConfirmModel(null)} />
              <Button label={t('Network.Yes')} color="error" onClick={handlesetParams} />
            </div>
          </div>
        }
      />
    </FollowCardItem>
  );
}